import XDate from "xdate";

// export const datetimeFormat = 'DD/MM/YYYY H:mm'
export function displayFormattedDate(dateString, withTime = true) {
  if (!dateString) return undefined;
  let fmt = "dd/MM/yyyy";
  if (withTime) {
    fmt = `${fmt} H:mm`;
  }
  let xd = new XDate(dateString);
  return xd.toString(fmt);
}

// export function convertTimeZoneName(name) {
//   return _.filter(moment.tz.names(), tz => {
//     return tz.search(name) !== -1
//   })[0]
// }
